var React = require('react');

function CloseFullscreen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 78.571h21.429V100h14.285V64.286H0V78.57ZM21.429 21.43H0v14.285h35.714V0H21.43v21.429ZM64.286 100H78.57V78.571H100V64.286H64.286V100ZM78.57 21.429V0H64.286v35.714H100V21.43H78.571Z"}));
}

CloseFullscreen.defaultProps = {"viewBox":"0 0 100 100"};

module.exports = CloseFullscreen;

CloseFullscreen.default = CloseFullscreen;
